import { render, staticRenderFns } from "./passwordChangeModal.vue?vue&type=template&id=5c4f4d62&"
import script from "./passwordChangeModal.vue?vue&type=script&lang=js&"
export * from "./passwordChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports